'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var idCounter = 0;
function idGen() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var id = ++idCounter; // eslint-disable-line no-plusplus
    return '' + (prefix + id);
}
exports.default = idGen;
//# sourceMappingURL=idGen.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/idGen.js